/**
 * @public {open} открыть меню
 * @public {close} закрыть меню
 * @param { array } data - данные для построения дерева вида
 * [ { title:'',  url:'', active: false, children:{...} } ]
 * */
class MenuApp {
  constructor(data, options) {
    if (!data || typeof data !== 'object') {
      return new Error('data not object');
    }
    this.options = Object.assign({
      title: 'Меню',
      dropdownBtn: '<svg class="c-icon c-icon-svg c-icon-svg-arrow-right">'
                  + '<use xlink:href="/assets/images/icons.svg#arrow-right"></use></svg>',
      closeBtn: '<svg class="c-icon c-icon-svg c-icon-svg-close">'
                  + '<use xlink:href="/assets/images/icons.svg#close"></use></svg>',
      backBtn: '<svg class="c-icon c-icon-svg c-icon-svg-arrow-left">'
                  + '<use xlink:href="/assets/images/icons.svg#arrow-left"></use></svg>',
      footerHtml: null,
    }, options);
    this.data = data;
    this.active = false;
    this.current = [];
    this.menu = this.createMenu();
    this.overlay = this.makeOverlay();
    this.onOpen = () => false;
    this.onClose = () => false;
  }

  makeItem(item, index, parentIndex) {
    if (item.category && item.children) {
      return `<div class="c-menu-app__category">
            <div class="c-menu-app__category-title">${item.category}</div>
            ${this.makeList(item.children)}
      </div>`;
    }
    const delay = `${index * 50}ms`;
    const itemIndex = parentIndex !== undefined ? [parentIndex, index] : index;
    const dataCount = item.count ? `data-count="${item.count}"` : '';
    let dataAttr = `data-action="dropdown" data-index="${itemIndex}"`;
    let activeClass = item.active ? 'is-active' : '';
    let dropdownClass = '';
    let toggle = '';
    let collapsed = '';
    let link = `<span ${dataCount} class="c-menu-app__item-link">${item.title}</span>`;
    if (item.children) {
      dropdownClass = 'has-dropdown';
      toggle = `<button ${dataAttr} class="c-menu-app__toggle">${this.options.dropdownBtn}</button>`;
      if (item.collapse) {
        dropdownClass = 'has-collapse';
        dataAttr = 'data-action="collapse"';
        toggle = `<button ${dataAttr} class="c-menu-app__toggle"></button>`;
        collapsed = `<div class="c-menu-app__dropdown" style="display: none">
                    ${this.makeList(item.children, index)}</div>`;
      }
      link = `<span ${dataAttr} ${dataCount} class="c-menu-app__item-link">${item.title}</span>`;
    }
    if (!item.active && item.url) {
      const urls = [
        window.location.href,
        window.location.pathname + window.location.search,
        window.location.pathname,
      ];
      urls.forEach((url) => {
        if (url === item.url) {
          activeClass = 'is-active';
          return activeClass;
        }
        return url;
      });
    }
    if (item.url) {
      link = `<a class="c-menu-app__item-link"  ${dataCount} href="${item.url}">${item.title}</a>`;
    }
    return `<div class="c-menu-app__item ${activeClass} ${dropdownClass}" 
            style="animation-delay:${delay}">${link}${toggle}${collapsed}</div>`;
  }

  makeList(root, parentIndex) {
    const items = root.map((item, index) => `<li>${this.makeItem(item, index, parentIndex)}</li>`);
    return `<ul>${items.join('')}</ul>`;
  }

  getItem(path) {
    let target = this.data;
    path.forEach((index) => {
      let newTarget = target[index];
      if (target.children && target.children[index] && target.children[index].children) {
        newTarget = target.children[index];
      }
      if (newTarget) target = newTarget;
    });
    return target;
  }

  render(title, menu) {
    let head = '';
    let footer = this.options.footerHtml ? this.options.footerHtml : '';
    const back = `<button class="c-menu-app__back" 
                    data-action="back">${this.options.backBtn}</button>`;
    const body = `<div class="c-menu-app__body"><div class="c-menu-app__nav">${menu}</div></div>`;
    const close = `<div class="c-menu-app__aside">
                    <button class="c-menu-app__close"
                     data-action="close">${this.options.closeBtn}</button></div>`;
    if (footer) {
      footer = `<div class="c-menu-app__footer">${footer}</div>`;
    }
    if (this.current.length) {
      this.menu.classList.add('child-opened');
      head = `<div class="c-menu-app__head">${back}
                    <div class="c-menu-app__title" 
                    data-action="back">${title || this.options.title}</div></div>`;
    }
    return `<div class="c-menu-app__inner">${head}${body}${footer}${close}</div>`;
  }

  makeOverlay() {
    const overlay = document.createElement('div');
    overlay.className = 'c-menu-app-overlay';
    overlay.style.display = 'none';
    this.overlay = overlay;
    this.overlay.onclick = () => {
      this.close();
    };
    return overlay;
  }

  open(callback) {
    if (!this.menu) return false;
    this.active = true;
    this.menu.classList.add('is-active');
    this.menu.style.display = 'block';
    this.overlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
    if (callback && typeof callback === 'function') callback(this.menu);
    if (typeof this.onOpen === 'function') this.onOpen(this.menu);
    return this.menu;
  }

  close(callback) {
    if (!this.menu) return false;
    this.menu.classList.remove('is-active');
    this.active = false;
    this.menu.style.display = 'none';
    this.overlay.style.display = 'none';
    document.body.style.overflow = '';
    if (callback && typeof callback === 'function') callback(this.menu);
    if (typeof this.onClose === 'function') this.onClose(this.menu);
    return this.menu;
  }

  bindEvents(menu) {
    const actions = {
      dropdown: (target) => {
        const index = target.dataset.index.split(',');
        const children = [].concat(this.current, index);
        this.current.push(index[0]);
        const item = this.getItem(children);
        this.menu.innerHTML = this.render(item.title, this.makeList(item.children));
        return this.menu;
      },
      collapse: (target) => {
        const item = target.parentNode;
        const menuCollapse = item.querySelector('.c-menu-app__dropdown');
        if (item.classList.contains('is-expanded')) {
          target.classList.remove('is-active');
          item.classList.remove('is-expanded');
          menuCollapse.style.display = 'none';
        } else {
          target.classList.add('is-active');
          item.classList.add('is-expanded');
          menuCollapse.style.display = '';
        }
      },
      back: () => {
        if (!this.current.length) return false;
        this.current.pop();
        const item = this.getItem(this.current);
        const dropdown = item.children || item;
        const title = item.title || this.options.title;
        this.menu.innerHTML = this.render(title, this.makeList(dropdown));
        return this.menu;
      },
      close: () => this.close(),
    };
    menu.addEventListener('click', (event) => {
      let { target } = event;
      while (target !== menu) {
        if (target.dataset && target.dataset.action) {
          const { action } = target.dataset;
          if (actions[action]) actions[action](target);
          event.preventDefault();
          break;
        }
        target = target.parentNode;
      }
    });
  }

  createMenu() {
    this.menu = document.createElement('nav');
    this.menu.className = 'c-menu-app';
    this.menu.style.display = 'none';
    this.menu.innerHTML = this.render(this.options.title, this.makeList(this.data));
    this.bindEvents(this.menu);
    return this.menu;
  }
}

export default MenuApp;
